var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46704 13.3017C3.46704 8.62125 7.26662 4.82258 11.9462 4.82258C16.6258 4.82258 20.4254 8.62125 20.4254 13.3017C20.4254 13.4841 20.4978 13.659 20.6267 13.7879C20.7557 13.9168 20.9305 13.9892 21.1129 13.9892C21.2952 13.9892 21.4701 13.9168 21.599 13.7879C21.7279 13.659 21.8004 13.4841 21.8004 13.3017C21.8004 7.86225 17.3848 3.44758 11.9462 3.44758C6.50762 3.44758 2.09204 7.86225 2.09204 13.3017C2.09204 13.4841 2.16447 13.659 2.29341 13.7879C2.42234 13.9168 2.5972 13.9892 2.77954 13.9892C2.96188 13.9892 3.13675 13.9168 3.26568 13.7879C3.39461 13.659 3.46704 13.4841 3.46704 13.3017Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.095 10.0522L12.4375 13.783C12.3083 13.9067 12.1361 13.9753 11.9573 13.9743C11.7784 13.9732 11.607 13.9027 11.4793 13.7775C11.3516 13.6522 11.2776 13.4823 11.273 13.3035C11.2685 13.1247 11.3337 12.9512 11.4548 12.8196L15.1132 9.08967C14.2011 8.40115 13.089 8.02938 11.9461 8.03092C10.5484 8.0314 9.20799 8.58688 8.21962 9.57525C7.23125 10.5636 6.67578 11.904 6.67529 13.3018C6.67602 14.6994 7.23157 16.0397 8.21989 17.028C9.2082 18.0163 10.5484 18.5719 11.9461 18.5726C13.3438 18.5719 14.684 18.0163 15.6724 17.028C16.6607 16.0397 17.2162 14.6994 17.217 13.3018C17.2187 12.1233 16.8235 10.9785 16.095 10.0522Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnobIcon);
export default __webpack_public_path__ + "static/media/knob-icon.b954091e9636fa3ed35e8b3c04da5de4.svg";
export { ForwardRef as ReactComponent };